import { useMutation, useQueryClient } from 'react-query';
import { reactivateTeamMember } from 'resources/user/workflows/reactivateTeamMember';
import uiNotifications from 'services/uiNotification.service';


export default function useReactivateTeamMember(queryOptions) {
  const queryClient = useQueryClient();

  return useMutation(
    (requestData) => reactivateTeamMember(requestData),
    {
      onSuccess: async (response) => {
        if (!response || response.isBadRequest) {
          return;
        }

        queryClient.invalidateQueries(['users.userById', response.id]);
        queryClient.invalidateQueries(['users.companyUsers', response.company_id]);

        uiNotifications.showSuccess(`Reactivated successfully.`);
      },
      onError: (error) => {
        uiNotifications.showExtractedError(error, 'Reactivation failed. ', { duration: 10 });
      },
    },
  );
};
